import {FC, useEffect} from 'react'

import { DOCLabelFormViewProvider } from './components/DOCLabelFormContextProvider'
import { DOCLabelRequestModalHeader } from './DOCLabelRequestModalHeader'
import { DOCLabelRequestModalContent } from './DOCLabelRequestModalContent'

import { IDOCLabelApplication } from './core'

type Props = {
  initData: IDOCLabelApplication,    
  submitFn: Function
  onSuccess: Function
  cancelForm: Function
}

const DOCLabelRequestModal: FC<Props> = ({initData, submitFn, onSuccess, cancelForm}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
  <DOCLabelFormViewProvider initData={initData} submitFn={submitFn} onSuccess={onSuccess} cancelForm={cancelForm}>
  <div
    className='modal fade show d-block'
    id='kt_modal_doclabel_request'
    role='dialog'
    tabIndex={-1}
    aria-modal='true'
  >
    <div className='modal-dialog modal-dialog-centered mw-1000px'>
      <div className='modal-content'>
        <DOCLabelRequestModalHeader />
        <div className='modal-body mx-xl-10'>
          <DOCLabelRequestModalContent />
        </div>        
      </div>            
    </div>        
  </div>    
  <div className='modal-backdrop fade show'></div>    
  </DOCLabelFormViewProvider>
  )
}

export {DOCLabelRequestModal}
